import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import * as Guards from '@box-core/guards';

import * as Pages from './pages';
import { settingsNavItems, termsAndPoliciesNavItems, termsNavItems } from '@box-configs/nav-items.options';

const routes: Routes = [
  {
    path: '',
    component: Pages.AccountPage,
    data: { name: 'Acount', breadcrumbName: 'account_' },
    children: [
      { path: '', redirectTo: 'user-details', pathMatch: 'full' },
      {
        path: 'user-details',
        component: Pages.AccountDetailsPage,
        data: { name: 'Account Details Page', breadcrumbName: 'user_details' },
        canActivate: [Guards.AuthGuard]
      },
      {
        path: 'contact',
        component: Pages.AccountContactPage,
        data: { name: 'Account Contact Page', breadcrumbName: 'contact_data' },
        canActivate: [Guards.AuthGuard]
      },
      {
        path: 'addresses',
        component: Pages.AccountAddressesPage,
        data: { name: 'Account Addresses Page', breadcrumbName: 'addresses_' },
        canActivate: [Guards.AuthGuard]
      },
      {
        path: 'cards',
        component: Pages.AccountCardsPage,
        data: { name: 'Account Cards Page', breadcrumbName: 'payment_cards' },
        canActivate: [Guards.AuthGuard]
      },
      {
        path: 'supermarket-cards',
        component: Pages.AccountMarketCardsPage,
        data: { name: 'Market Cards Page', breadcrumbName: 'supermarket_cards' },
        canActivate: [Guards.AuthGuard]
      },
      {
        path: 'referral',
        component: Pages.AccountReferralPage,
        data: { name: 'Account Referral Page', breadcrumbName: 'bring_a_friend' },
        canActivate: [Guards.AuthGuard]
      },
      {
        path: 'settings',
        component: Pages.AccountSubmenuPage,
        data: { name: 'Account Settings Page', breadcrumbName: 'settings_', navItems: settingsNavItems },
        children: [
          {
            path: 'language',
            component: Pages.AccountSettingsLanguageComponent,
            data: { name: 'Account Language Page', breadcrumbName: 'language_' }
          },
          {
            path: 'dark-mode',
            component: Pages.AccountSettingsThemeComponent,
            data: { name: 'Account Dark Theme Page', breadcrumbName: 'dark_mode' }
          }
        ]
      },
      {
        path: 'contests',
        component: Pages.AccountContestsPage,
        data: { name: 'Account Contests Page', breadcrumbName: 'contests_' },
        canActivate: [Guards.AuthGuard]
      },
      {
        path: 'history',
        component: Pages.AccountHistoryPage,
        data: { name: 'Account History Page', breadcrumbName: 'order_history' },
        canActivate: [Guards.AuthGuard]
      },
      {
        path: 'terms',
        component: Pages.AccountSubmenuPage,
        data: {
          name: 'Account Terms Page',
          breadcrumbName: 'terms_and_policies',
          navItems: termsAndPoliciesNavItems
        },
        children: [
          {
            path: 'box-terms-of-use',
            component: Pages.AccountTermsSubPage,
            data: { name: 'Account Box Terms Of Use Page', breadcrumbName: 'box_terms_of_use', templateType: 'terms' }
          },
          {
            path: 'terms-and-conditions-for-the-provision-of-postal-services',
            component: Pages.AccountTermsSubPage,
            data: {
              name: 'Account Terms And Conditions For The Provision Of Postal Services Page',
              breadcrumbName: 'terms_and_conditions_for_the_provision_of_postal_services',
              templateType: 'postalServicesProvision'
            }
          },
          {
            path: 'charter-of-obligations-towards-consumers',
            component: Pages.AccountTermsSubPage,
            data: {
              name: 'Account Charter Of Obligations Towards Consumers Page',
              breadcrumbName: 'charter_of_obligations_towards_consumers',
              templateType: 'obligationsTowardsCharter'
            }
          },
          {
            path: 'policy-against-misuse',
            component: Pages.AccountTermsSubPage,
            data: {
              name: 'Account Policy Against Misuse Page',
              breadcrumbName: 'policy_against_misuse',
              templateType: 'policyAgainstMisuse'
            }
          },
          {
            path: 'complaint-handling-policy',
            component: Pages.AccountTermsSubPage,
            data: {
              name: 'Account Complaint Handling Policy Page',
              breadcrumbName: 'complaint_handling_policy',
              templateType: 'complaintHandlingPolicy'
            }
          },
          {
            path: 'transparency-report',
            component: Pages.AccountTransparencyReportPage,
            data: {
              name: 'Account Transparency Report Page',
              breadcrumbName: 'transparency_report'
            }
          }
        ]
      },
      {
        path: 'personal-data',
        component: Pages.AccountSubmenuPage,
        data: { name: 'Account Personal Data Page', breadcrumbName: 'personal_data', navItems: termsNavItems },
        children: [
          {
            path: 'policy',
            component: Pages.AccountPolicyTermsPage,
            data: { name: 'Account Policy Page', breadcrumbName: 'privacy_update' }
          },
          {
            path: 'personalisation',
            component: Pages.AccountPersonalisationTermsPage,
            data: { name: 'Account Personalisation Page', breadcrumbName: 'terms_of_personalization' },
            canActivate: [Guards.AuthGuard]
          },
          {
            path: 'delete-profile',
            component: Pages.AccountDeleteProfilePage,
            data: { name: 'Account Delete Account Page', breadcrumbName: 'delete_profile' },
            canActivate: [Guards.AuthGuard]
          }
        ]
      },
      {
        path: 'faqs',
        component: Pages.AccountUsefulLinksFAQPage,
        data: { name: 'Account FAQs Page', breadcrumbName: 'faqs_' }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AccountRoutingModule {}
